/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import React from 'react';
import { TranslationDto } from '@ink-ai/insight-service-sdk';
import { EllipsisCell } from './EllipsisCell';

interface TranslationsCellProps {
  translations: TranslationDto[] | null;
}

export const TranslationsCell: React.FC<TranslationsCellProps> = ({
  translations,
}) => {
  const formatTranslations = (
    translations: TranslationDto[] | null,
  ): React.ReactNode => {
    if (!translations) return '-';
    return translations
      .map(
        (translation) => `${translation.language}: ${translation.translation}`,
      )
      .join(', ');
  };

  const tooltipContent = (
    <div>
      {translations
        ? translations.map((translation, index) => (
            <div
              key={index}
            >{`${translation.language}: ${translation.translation}`}</div>
          ))
        : '-'}
    </div>
  );

  return (
    <EllipsisCell
      content={formatTranslations(translations)}
      tooltip={tooltipContent}
      formatContent={(content) => content}
      maxLines={3}
    />
  );
};
